/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useState, useEffect} from 'react'
import {KTSVG} from '../../../_metronic/helpers'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import FloatingLabel from 'react-bootstrap/FloatingLabel'
import {useParams} from 'react-router-dom'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import {useTranslation} from 'react-i18next'
import {
  getSIPDetail,
  revisionSIP,
  rejectSIP,
  approveSIP,
  getAccesses,
  unduhSIP
} from '../../../api/modules/sip'
import AddRemoveJadwal from './AddRemoveJadwal'
import swal from 'sweetalert'
import {useNavigate} from 'react-router-dom'
import {PageTitle} from '../../../_metronic/layout/core'
import {create, getFile, deleteFile} from '../../../api/modules/file'
import {useDispatch, useSelector} from 'react-redux'
import {setGetNotif} from '../../../_metronic/redux/content'
import {Spinner} from 'react-bootstrap'
import i18next from 'i18next'
import {PopoverText} from '../../../components/Popover/Popover'
import {getRoleFlagList} from '../../../api/modules/master-data/master_2'
import {MultiSelect} from 'react-multi-select-component'
import {PriceFormater} from '../../../components/mikro/PriceFormater'
import {CustomModal} from '../../../components/CustomModal'
import {FormDetailSIP} from './FormDetailSIP'
import {useAppDispatch, useAppSelector} from '../../../redux/hooks'
import {appSelector, setOrderDetail, setOrderSubDetail} from '../../../redux/slices/appSlices'
import {TOrderSubDetail} from '../../../redux/types'
import {authSelector} from 'src/redux/slices/authSlices'
import ViewLetter from 'src/components/Letter/ViewLetter'
import {BadgeColorSIP} from 'src/components/BadgeColorSIP'
import dateformat from 'src/utils/dateformat'
import {CheckSameIDAttachment} from 'src/components/mikro/CheckSameIDAttachment'
import {FindTodayDate_DDMMYY} from 'src/components/mikro/FindTodayDate_DDMMYY'
import Skeleton from 'react-loading-skeleton'
import * as TableUI from '../../../components/Table/Table'
import { InputFile } from 'src/app/components/InputFile'
import { handleDownloadAttachment } from 'src/app/helpers/file'
import { SkeletonPageDetail } from 'src/components'
import { SIPHistories } from './SIPHistories'
import ListHistorySIP from './ListHistorySIP'
import { ApprovalHistory } from './ApprovalHistory'
import { ApprovalHistoryPreview } from './ApprovalHistoryPreview'

const SIPDetail: React.FC = () => {
  const dispath = useDispatch()
  const notif = useSelector((state: any) => state.notif.getNotif)
  const appDispatch = useAppDispatch()
  const {roleId} = useAppSelector(authSelector)
  const {selectedMenu} = useAppSelector(appSelector)
  const params = useParams()

  const [show1, setShow1] = useState(false)
  
  const hasDeleteAttachment = selectedMenu?.attachment_delete ?? false
  const {t} = useTranslation()
  const [btnLoading, setBtnLoading] = useState(false)

  //#region
  const [dataSIPDetail, setDataSIPDetail] = useState<any[]>([])
  const [sipNumber, setSIPNumber] = useState('')
  const [sipStatusText, setSIPStatusText] = useState('')
  const [sipStatus, setSIPStatus] = useState(0)
  const [customer, setCustomer] = useState('')
  const [regarding, setRegarding] = useState('')
  const [perihalTanggal, setPerihalTanggal] = useState('')
  const [dateFrom, setDateFrom] = useState('')
  const [dateTo, setDateTo] = useState('')
  const [price, setPrice] = useState(0)
  const [quantum, setQuantum] = useState<any>()
  const [loading, setLoading] = useState(false)
  const [revisionNote, setRevisionNote] = useState('')
  const [rejectNote, setRejectNote] = useState('')
  const [SIPNumberAttactment, setSIPNumberAttactment] = useState(null)
  const [rollbackFlag, setRollbackFlag] = useState(false)
  const [showReject, setShowReject] = useState(false)
  const [showRevision, setShowRevision] = useState(false)
  const [showApprove, setShowApprove] = useState(false)
  const [statusID, setStatusID] = useState(0)
  const [sektorID, setSektorID] = useState(0)
  const [detailOrder, setDetailOrder] = useState<any>({})
  const [showDetail, setShowDetail] = useState(false)
  const [showJadwal, setShowJadwal] = useState(false)
  const [fullRole, setFullRole] = useState<any[]>([])
  const [tempRole, setTempRole] = useState<any[]>([])
  const [plant, setPlant] = useState('')
  const [plantDesc, setPlantDesc] = useState('')
  const [custAccount, setCustAccount] = useState('')
  const [retailFlag, setRetailFlag] = useState('')
  const [approveFlag, setApproveFlag] = useState(false)
  const [accesses, setAccesses] = useState<any>()
  const [grandtotal, setGrandtotal] = useState(0)
  const [grandtotalUsd, setGrandtotalUsd] = useState(0)
  const [kepada, setKepada] = useState('')
  const [lain, setLain] = useState('')
  const [footerContent, setFooterContent] = useState('')
  const [bodyContent, setBodyContent] = useState('')
  const [signername, setSignerName] = useState('')
  const [signerposition, setSignerPositon] = useState('')
  const [showLetter, setShowLetter] = useState(false)
  const [nomorSIP, setNomorSIP] = useState('')
  const [tanggalApprove, setTanggalApprove] = useState('')
  const [isLoadingModal, setIsLoadingModal] = useState(false)
  const [regardingSIP, setRegardingSIP] = useState('')
  const [regardingSIPDesc, setRegardingSIPDesc] = useState('')
  const [revisi_count, setRevisi_count] = useState('')
  //#endregion

  const navigate = useNavigate()
  const [roleUser, setRoleUser] = useState('')

  const [customerCode, setCustomerCode] = useState('')
  const [customerName, setCustomerName] = useState('')
  const [customerAddress, setCustomerAddress] = useState('')
  const [paymentMethod, setPaymentMethod] = useState('')
  const [fileBox, setFileBox] = useState<any>({})
  const [previewSector, setPreviewSector] = useState('')
  const SIPId = params?.id || sessionStorage.getItem('SI_ID')
  const [orderPaymentTypes, setOrderPaymentTypes] = useState<String[]>([])
  const [showApprovalHistory, setShowApprovalHistory] = useState(false)
  const [reviewers, setReviewers] = useState<any[]>([])
  const [approvers, setApprovers] = useState<any[]>([])

  const getSIP = async () => {
    setLoading(true)
    const res = await getSIPDetail(
      params?.id || sessionStorage.getItem('SI_ID'),
      localStorage.getItem('credential')
    )
    // console.log(res.data.data)
    appDispatch(setOrderDetail(res.data.data))
    if (!res.data.error) {
      if (localStorage.getItem('role-flag') === 'salesAnper') dispath(setGetNotif(!notif))
      setDataSIPDetail(res.data.data.order_sub_details)
      setRegardingSIP(res.data?.data?.sip_type)
      setRegardingSIPDesc(res.data?.data?.sip_type_desc)
      setRevisi_count(res.data?.data?.amendment_counting)
      setNomorSIP(res.data.data.SIP_number)
      setTanggalApprove(res.data.data.approved_date ? res.data.data.approved_date : '')
      setKepada(res.data.data.kepada)
      setLain(res.data.data.lain_lain)
      setBodyContent(res.data.data.body_content)
      setFooterContent(res.data.data.footer_content)
      setSignerName(res.data.data.signer_name)
      setSignerPositon(res.data.data.signer_position)
      setCustAccount(res.data.data.customer?.customer_account_group)
      setStatusID(res.data.data.status)
      setSIPNumber('10' + res.data.data.pengajuan_order.po_number)
      setSIPStatusText(res.data.data.status_text)
      setSIPStatus(res.data.data.status)
      setCustomer(res.data.data.customer?.title + ' ' + res.data.data.customer?.name)
      setRegarding(res.data.data.pengajuan_order.regarding)
      setPerihalTanggal(res.data.data.estimate_date)
      setDateFrom(res.data.data.valid_date_from)
      setDateTo(res.data.data.valid_date_to)
      setSektorID(res.data.data.sector_id)
      setRollbackFlag(res.data.data.show_btn_rollback)
      setRetailFlag(res.data.data.customer?.customer_account_group)
      let temptotal = 0
      let temptotalusd = 0

      const _payment_types: String[] = [...orderPaymentTypes]
      res.data.data.order_sub_details?.forEach((value: any) => {
        temptotal = temptotal + parseFloat(value?.fixed_price) * parseFloat(value?.fixed_quantum)
        temptotalusd = temptotalusd + parseFloat(value?.price_usd) * parseFloat(value?.fixed_quantum)

        if(value?.sector){
          setPreviewSector(value?.sector?.name)
        }

        if(value?.payment_type_1_desc && !_payment_types.includes(value?.payment_type_1_desc)) {
          _payment_types.push(value?.payment_type_1_desc)
        }
        if(value?.payment_type_2_desc && !_payment_types.includes(value?.payment_type_2_desc)) {
          _payment_types.push(value?.payment_type_2_desc)
        }
      })
      setOrderPaymentTypes(_payment_types)
      setGrandtotal(temptotal)
      setGrandtotalUsd(temptotalusd)
      setPrice(res.data.data.price)
      setQuantum(res.data.data.total_quantum)
      setApproveFlag(res.data.data.show_btn_approve)
      setCustomerCode(res.data.data.customer?.customer_code)
      setCustomerName(res.data.data.customer?.name)
      setCustomerAddress(res.data.data.customer?.address)
      setPaymentMethod(res.data.data.payment_method_info)

      setReviewers(res.data.data.sip_reviewers)
      setApprovers(res.data.data.sip_approvers)
    }

    setLoading(false)
  }

  const disableBtn = () => {
    const reject = document.getElementById(`btn-reject`) as HTMLInputElement
    const approve = document.getElementById(`btn-approve`) as HTMLInputElement
    const revision = document.getElementById(`btn-revision`) as HTMLInputElement

    reject.disabled = true
    approve.disabled = true
    revision.disabled = true

    reject.hidden = true
    approve.hidden = true
    revision.hidden = true
  }

  const handleshowjadwal = () => {
    const getData = setTimeout(async () => {
      setShowJadwal(true)
    }, 2000)

    return () => clearTimeout(getData)
  }

  const [previewSegment, setPreviewSegment] = useState<any[]>([])

  const LetterData = {
    kepada: kepada,
    produsen: dataSIPDetail[0]?.produsen?.name,
    customer: customer,
    subItem: dataSIPDetail,
    dateFrom: dateFrom,
    dateTo: dateTo,
    includePpn: dataSIPDetail[0]?.include_ppn,
    paymentInfo: paymentMethod,
    paymentMethod: dataSIPDetail,
    lainlain: lain,
    signername: signername,
    singerposition: signerposition,
    sector: sektorID,
    tanggalApprove: FindTodayDate_DDMMYY(tanggalApprove),
    noSIP: nomorSIP,
    tipePembayaranSIP: paymentMethod || orderPaymentTypes?.join(", "),
    footerContent: footerContent ? footerContent : '',
    bodyContent: bodyContent ? bodyContent : '',
    sectorName: previewSector,
    segments: previewSegment,
    regardingSIP: regardingSIP,
    regardingSIPDesc: regardingSIPDesc,
    revisi_count: revisi_count,
  }

  useEffect(() => {
    const role = () => {
      const role: any = localStorage.getItem('role-flag')
      setRoleUser(role)
    }

    const getAccessMenu = async () => {
      setLoading(true)
      const res = await getAccesses(roleId)
      setAccesses(res.data.data)
    }

    const getAllRoleList = async () => {
      const res = await getRoleFlagList()
      setFullRole(res.data.data)
    }

    getAccessMenu()
    role()
    getSIP()
    getAllRoleList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const Revision = async () => {
    setBtnLoading(true)
    await revisionSIP(params?.id || parseInt(sessionStorage.getItem('SI_ID')!), revisionNote, i18next.language)
      .then((res) => {
        if (!res.data.error) {
          swal({
            title: `${t('revisionSuccess')}`,
            icon: 'success',
          }).then(() => {
            disableBtn()
            dispath(setGetNotif(!notif))
            setShowRevision(false)
            navigate('/management/si/all')
          })
        } else
          swal({
            title: `${res.data}`,
            icon: 'error',
          })
      })
      .catch(function (error) {
        if (error.response) {
          swal({
            title: `${error.response.data.message}`,
            icon: 'error',
          })
        }
      })
      .finally(() => {
        setBtnLoading(false)
      })
  }

  const Approve = async () => {
    setBtnLoading(true)
    await approveSIP(params?.id || parseInt(sessionStorage.getItem('SI_ID')!), localStorage.getItem('credential'))
      .then((res) => {
        if (!res.data.error) {
          swal({
            title: `${t(res.data.message)}`,
            icon: 'success',
          })
          disableBtn()
          dispath(setGetNotif(!notif))
          setShowApprove(false)
        } else {
          if (res.data.match(/League\\Flysystem\\Filesystem::delete(): Argument #1/g)) {
            swal({
              title: t('Error-pengirimanKhusus'),
              icon: 'error',
            })
          } else {
            swal({
              title: t(res.data),
              icon: 'error',
            })
          }
        }
      })
      .catch(function (error) {
        if (error.response) {
          swal({
            title: `${t(error.response.data.message)}`,
            icon: 'error',
          })
        }
      })
      .finally(() => {
        setBtnLoading(false)
      })
  }

  const Reject = async () => {
    setBtnLoading(true)
    await rejectSIP(params?.id || parseInt(sessionStorage.getItem('SI_ID')!), rejectNote)
      .then((res) => {
        if (!res.data.error) {
          swal({
            title: `${t('rejectSuccess')}`,
            icon: 'success',
          }).then(() => {
            // disableBtn()
            // dispath(setGetNotif(!notif))
            setShowRevision(false)
            navigate('/management/si/all')
          })
        } else
          swal({
            title: `${res.data}`,
            icon: 'error',
          })
      })
      .catch(function (error) {
        if (error.response) {
          swal({
            title: `${error.response.data.message}`,
            icon: 'error',
          })
        }
      })
      .finally(() => {
        setBtnLoading(false)
      })
  }

  const [showUpload, setShowUpload] = useState(false)
  const [allFiles, setAllFiles] = useState<any[]>([])
  const [files, setFiles] = useState({file: null})
  const [namaFile, setNamaFile] = useState('')
  const [description, setDescription] = useState('')
  const [isPrivate, setIsPrivate] = useState(false)
  const [dataType, setDataType] = useState('')
  const [subOrderID, setSubOrderID] = useState('')
  const [provinceName, setProvinceName] = useState('')
  const [cityName, setCityName] = useState('')
  const [productName, setProductName] = useState('')
  const [fixedQuantum, setFixedQuantum] = useState('')
  const [idSektor, setIDSector] = useState(0)
  const [attachmentType, setAttachmentType] = useState('order-item')

  const formattingTon = (ton: any) => {
    let tempTon = parseFloat(ton)
    let temp = ''
    if (i18next.language == 'en') {
      temp = tempTon.toLocaleString('en', {maximumFractionDigits: 4})
    } else {
      temp = tempTon.toLocaleString('id', {maximumFractionDigits: 4})
    }
    setFixedQuantum(temp)
  }

  const ambilAttachment = async (id: any, type: any = null) => {
    if(type) setAttachmentType(type)
    await getFile(type || attachmentType, id, localStorage.getItem('credential')!).then((res) => {
      setAllFiles(res.data.data)
      setShowUpload(true)
      setIsLoadingModal(false)
    })
  }

  const clearFile = () => {
    const inputfile = document.getElementById('upload') as HTMLInputElement
    inputfile.value = ''
    const inputPrivate = document.getElementById('isPrivate') as HTMLInputElement
    inputPrivate.checked = false
  }

  const deleteAttachment = async (id: any) => {
    swal({
      title: `${t('Are you sure?')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Yes')}`],
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        await deleteFile(id)
          .then(() => {
            swal({
              closeOnClickOutside: false,
              title: t('Dokumen Berhasil Dihapus'),
              icon: 'success',
            })
            ambilAttachment(subOrderID)
          })
          .catch((error) => {
            swal({
              title: error.response.data,
              icon: 'error',
            })
          })
      }
    })
  }

  const handleUpload = async () => {
    setBtnLoading(true)
    let file = files.file
    let formdata = new FormData()
    let temparray: any[] = []
    if (tempRole.length > 0) {
      tempRole.forEach((data: any) => {
        temparray.push(data.value)
      })
    }
    formdata.append('file_r', file!)
    formdata.append('name', namaFile!)
    formdata.append('description', description!)
    formdata.append('attach_parent', subOrderID)
    formdata.append('file_type', dataType)
    formdata.append('private', isPrivate.toString())
    formdata.append('roles', JSON.stringify(temparray))
    if (SIPNumberAttactment) {
      formdata.append('unique_number', SIPNumberAttactment)
      formdata.append('unique_flag', 'new_sip_osd')
    }
    formdata.append('credentials', localStorage.getItem('credential')!)
    // console.log(formdata)
    await create(attachmentType, formdata)
      .then((res) => {
        swal({
          title: `${t('document uploaded successfully')}`,
          icon: 'success',
        }).then(() => {
          setNamaFile('')
          setDescription('')
          setDataType('')
          setIsPrivate(false)
          setTempRole([])
          setFiles({file: null})
          clearFile()
        })
        ambilAttachment(subOrderID)
      })
      .catch(function (error) {
        swal({
          title: t(error.response.data.message),
          icon: 'error',
        })
      })
      .finally(() => {
        setBtnLoading(false)
      })
  }

  /**
   * Mengubah data.end_user
   *
   * @example "iwan,agus,budi" menjadi "iwan, agus, budi"
   * @returns
   */
  const getEndUser = (data: any) => data.end_user.replace(/,/g, ', ')

  const handleShowOrderDetail = (data: TOrderSubDetail) => {
    appDispatch(setOrderSubDetail(data))
    setDetailOrder(data)
    setShowDetail(true)
  }

  function handleShowRoleName(role: any) {
    let temp = ''
    role.forEach((element: any, index: any) => {
      if (index + 1 == role.length) temp = temp + element
      else temp = temp + element + ', '
    })
    return temp
  }

  useEffect(() => {
    setPreviewSegment([]);
    let _segments: any[] = [];
    dataSIPDetail.forEach((item: any) => {
      if(item.segment_name && !_segments.includes(item.segment_name)){
        _segments.push(item.segment_name)
      }
    })
    setPreviewSegment(_segments);
  }, [dataSIPDetail])

  const [loadingDownloadDraft, setLoadingDownloadDraft] = useState(false)
  const handleDownloadDraft = async () => {
    if(loadingDownloadDraft) return
    try {
      setLoadingDownloadDraft(true)

      const response = await unduhSIP(
        params?.id || parseInt(sessionStorage.getItem('SI_ID')!),
        i18next.language
      );
      const href = URL.createObjectURL(response.data)

      let file_name = `11${nomorSIP}_${customerName}.pdf`

      if ([4,5,6,7,8,9,11].includes(sipStatus)) {
        file_name = 'SIP_' + file_name
      } else {
        file_name = 'SIP_DRAFT_' + file_name
      }

      const link = document.createElement('a')
      link.href = href
      link.setAttribute('download', file_name)
      document.body.appendChild(link)
      link.click()

      document.body.removeChild(link)
      URL.revokeObjectURL(href)
      setLoadingDownloadDraft(false)
    } catch (error) {
      setLoadingDownloadDraft(false)
      swal({
        title: t('failed'),
        icon: 'error',
      })
    }
  }

  const [showModalHistory, setShowModalHistory] = useState(false)

  return (
    <>
      <PageTitle breadcrumbs={[]}>{t('page Detail sip')}</PageTitle>

      {!loading && [1,3].includes(sipStatus) && <>
        <div className='card mb-5'>
          <div className='card-body'>
              <ApprovalHistoryPreview reviewers={reviewers} approvers={approvers}/>
          </div>
        </div>
      </>}

      <div className='card'>
        <div className='card-body'>
          {!loading ? (
            <>
              {/* Old static condition */}
              {roleUser == 'admin' && (
                <>
                  <Row>
                    <Col md={6}>
                      <Row className='mb-3'>
                        <Col className='d-flex align-items-center' md={4}>
                          <p className='fs-4'>
                            {t('sip-pengajuan')} {t('Order')}{' '}
                          </p>
                        </Col>
                        <Col md={8}>
                          <Form.Control type='text' defaultValue={sipNumber} disabled size='sm' />
                        </Col>
                      </Row>
                      <Row className='mb-3'>
                        <Col md={4}>
                          <p className='fs-4 mt-2'>{t('Customer Name')}</p>
                        </Col>
                        <Col md={8}>
                          <Form.Control
                            type='text'
                            value={customerName}
                            placeholder={t('Customer Name')}
                            disabled
                            size='sm'
                          />
                        </Col>
                      </Row>

                      <Row className='mb-3'>
                        <Col md={4}>
                          <p className='fs-4 mt-2'>{t('Start-Date')}</p>
                        </Col>
                        <Col md={8}>
                          <Form.Control
                            type='text'
                            placeholder={t('Start-Date')}
                            defaultValue={dateformat(dateFrom)}
                            disabled
                            size='sm'
                          />
                        </Col>
                      </Row>

                      <Row className='mb-3'>
                        <Col md={4} className='d-flex align-items-center'>
                          <p className='fs-4'>{t('Tanggal Pengajuan SIP')}</p>
                        </Col>
                        <Col md={8}>
                          <Form.Control
                            type='text'
                            placeholder={t('Tanggal Pengajuan SIP')}
                            defaultValue={dateformat(perihalTanggal)}
                            disabled
                            size='sm'
                          />
                        </Col>
                      </Row>
                    </Col>
                    <Col md={6}>
                      <Row className='mb-3'>
                        <Col md={4}>
                          <p className='fs-4 mt-2'>{t('Customer Number')}</p>
                        </Col>
                        <Col md={8}>
                          <Form.Control
                            type='text'
                            value={customerCode}
                            placeholder={t('Customer Number')}
                            disabled
                            size='sm'
                          />
                        </Col>
                      </Row>
                      <Row className='mb-3'>
                        <Col md={4}>
                          <p className='fs-4 mt-2'>{t('Address')}</p>
                        </Col>
                        <Col md={8}>
                          <Form.Control
                            as='textarea'
                            value={customerAddress}
                            placeholder={t('Address')}
                            disabled
                            size='sm'
                          />
                        </Col>
                      </Row>
                      <Row className='mb-3'>
                        <Col md={4}>
                          <p className='fs-4 mt-2'>{t('End-Date')}</p>
                        </Col>
                        <Col md={8}>
                          <Form.Control
                            type='text'
                            placeholder={t('End-Date')}
                            defaultValue={dateformat(dateTo)}
                            disabled
                            size='sm'
                          />
                        </Col>
                      </Row>
                      <Row className='mb-3'>
                        <Col md={4} className='d-flex align-items-center'>
                          <p className='fs-4'>{t('Metode Pembayaran')}</p>
                        </Col>
                        <Col md={8}>
                          <Form.Control
                            style={{height: '40px'}}
                            value={paymentMethod}
                            placeholder={t('Metode Pembayaran')}
                            disabled
                            size='sm'
                          />
                        </Col>
                      </Row>
                      <Row className='mb-3'>
                        <Col md={4}>
                          <p className='fs-4 mt-2'>{t('order-perihal')}</p>
                        </Col>
                        <Col md={8}>
                          <Form.Control
                            placeholder={t('order-perihal')}
                            aria-label='Default select example'
                            size='sm'
                            value={regarding == 'PO001' ? t('penjualan') : t('Non-penjualan')}
                            disabled
                          />
                        </Col>
                      </Row>
                    </Col>
                  </Row>

                  <hr />

                  <div className='card-toolbar mt-5 d-flex justify-content-between align-items-center'>
                    <div className='d-flex'>
                      <Button
                        onClick={() => {
                          setShowLetter(true)
                        }}
                        className='btn btn-primary fw-semibold d-flex align-items-center'
                        data-bs-toggle='tooltip'
                        data-bs-placement='top'
                        data-bs-trigger='hover'
                        title={t('preview')}
                      >
                        <i className='fas fa-file'></i> {t('preview')}
                      </Button>
                      <Button
                        onClick={() => {
                          setShowApprovalHistory(true)
                        }}
                        className='btn btn-primary fw-semibold d-flex align-items-center ms-2'
                        data-bs-toggle='tooltip'
                        data-bs-placement='top'
                        data-bs-trigger='hover'
                        title={t('Approval')}
                      >
                        <i className='fas fa-check'></i> {t('Approval')}
                      </Button>
                    </div>
                  </div>

                  <div className='table-responsive mt-5 bdr'>
                    {/* Table Head */}
                    <TableUI.TableDetail colSpan={14}>
                      <TableUI.TableWrapper style={{marginBottom: 0}}>
                        <TableUI.Table>
                          <TableUI.THead>
                            <tr style={{backgroundColor: '#274070'}}>
                              <th>{t('kontrak-item')}</th>
                              <th>Status</th>
                              <th>{t('kontrak-aksi')}</th>
                              <th>Sales Org</th>
                              <th>{t('kontrak-incoterm')}</th>
                              <th>{t('kontrak-wilayah')}</th>
                              {sektorID == 1 && <th>{t('segment')}</th>}
                              <th>{t('sub-order-endUser')}</th>
                              {sektorID == 2 && <th>{t('Sektor')}</th>}
                              <th>{t('kontrak-jenis')}</th>
                              <th>{t('Product Code')}</th>
                              <th>{t('kontrak-nama')}</th>
                              <th>{t('kontrak-spek')}</th>
                              <th>{t('Kuantum Pengajuan')}</th>
                              {sektorID != 2 && <th>{t('sub-order-kuantumD')}</th>}
                              <th>{t('sub-order-hargaP')}</th>
                              {sektorID != 2 && <th>{t('sub-order-hargaD')}</th>}
                              {sektorID == 1 && <th>Status {t('Price')}</th>}
                              <th>{t('Tonase Kontrak')}</th>
                              <th>{t('Tonase SO')}</th>
                              <th>{t('Tonase DO')}</th>
                              <th>Outstanding SO</th>
                              <th>Outstanding {t('Kontrak')}</th>
                              {sektorID == 2 && <th>{t('kontrak-Gudang')}</th>}
                            </tr>
                          </TableUI.THead>
                          <TableUI.TBody>
                            {dataSIPDetail.map((data: any, _index: number) => {
                              return (
                                <tr key={data?.id ?? _index}>
                                  <td>
                                    <span className='d-block fs-6 py-3'>{_index + 1}</span>
                                  </td>
                                  <td>
                                    <BadgeColorSIP
                                      status={data?.status_sip}
                                      text={data?.status_text_sip}
                                      type='header'
                                    />
                                  </td>
                                  <td>
                                    <div
                                      className='d-flex justify-content-center align-items-center'
                                      style={{margin: '-1px 0 0 0'}}
                                    >
                                      <button
                                        className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                        data-bs-toggle='tooltip'
                                        data-bs-placement='top'
                                        data-bs-trigger='hover'
                                        title='Detail'
                                        onClick={() => handleShowOrderDetail(data)}
                                      >
                                        <KTSVG
                                          path='/media/icons/duotune/file-text-fill.svg'
                                          className='svg-icon-3'
                                        />
                                      </button>
                                      <button
                                        className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                        data-bs-toggle='tooltip'
                                        data-bs-placement='top'
                                        data-bs-trigger='hover'
                                        title={t('Jadwal')}
                                        onClick={() => {
                                          setIDSector(data.sector_id)
                                          setProvinceName(data.province?.region_name)
                                          setCityName(data.city?.city_name)
                                          setProductName(data.product_name)
                                          formattingTon(data.fixed_quantum)
                                          setSubOrderID(
                                            data.order_sub_item_id == null
                                              ? data?.id
                                              : data?.order_sub_item_id
                                          )
                                          handleshowjadwal()
                                        }}
                                      >
                                        <KTSVG
                                          path='/media/icons/duotune/calendar-check-fill.svg'
                                          className='svg-icon-3'
                                        />
                                      </button>
                                    </div>
                                  </td>
                                  <td>
                                    <span className='d-block fs-6 py-3'>{data.produsen?.name}</span>
                                  </td>
                                  {data.sector?.id == 2 ? (
                                    <>
                                      {data.incoterm2 == null ? (
                                        <td>
                                          <span className='d-block fs-6 py-3'>
                                            {data.incoterm1?.code}-{data.incoterm2_id}
                                          </span>
                                        </td>
                                      ) : (
                                        <td>
                                          <span className='d-block fs-6 py-3'>
                                            {data.incoterm1?.code}-{data.incoterm2?.code}
                                          </span>
                                        </td>
                                      )}
                                    </>
                                  ) : (
                                    <>
                                      {data.incoterm2 == null ? (
                                        <td>
                                          <span className='d-block fs-6 py-3'>
                                            {data.incoterm1?.code}
                                            {data.incoterm2_id == null || data.incoterm2_id == '0'
                                              ? ''
                                              : '-' + data.incoterm2_id}
                                          </span>
                                        </td>
                                      ) : (
                                        <td>
                                          <span className='d-block fs-6 py-3'>
                                            {data.incoterm1?.code}-{data.incoterm2?.code}
                                          </span>
                                        </td>
                                      )}
                                    </>
                                  )}
                                  <td>
                                    <span className='d-block fs-6 py-3'>
                                      <PopoverText
                                        content={
                                          data.province?.region_name ||
                                          '' +
                                            (data.city?.city_name
                                              ? ', ' + data.city?.city_name
                                              : '')
                                        }
                                        index={_index}
                                        className='spec-sliceee'
                                      />
                                    </span>
                                  </td>
                                  {sektorID == 1 ? (
                                    <td>
                                      <span className='d-block fs-6 py-3'>
                                        {t(data.segment_name)}
                                      </span>
                                    </td>
                                  ) : (
                                    ''
                                  )}
                                  <td>
                                    <span className='d-block fs-6 py-3'>
                                      <PopoverText
                                        content={getEndUser(data)}
                                        index={_index}
                                        className='desc-slicee'
                                      />
                                    </span>
                                  </td>
                                  {sektorID != 2 ? (
                                    ''
                                  ) : (
                                    <td>
                                      <span className='d-block fs-6 py-3'>
                                        {t(data.sector?.name)}
                                      </span>
                                    </td>
                                  )}
                                  <td>
                                    <span className='d-block fs-6 py-3'>
                                      {data.product_type_desc}
                                    </span>
                                  </td>
                                  <td>
                                    <span className='d-block fs-6 py-3'>
                                      {data.material_number?.slice(-7)}
                                    </span>
                                  </td>
                                  <td>
                                    <span className='d-block fs-6 py-3'>{data.product_name}</span>
                                  </td>
                                  <td>
                                    <span className='d-block fs-6 py-3'>
                                      <PopoverText
                                        content={data.product_spec || '-'}
                                        index={_index}
                                        className='spec-sliceee'
                                      />
                                    </span>
                                  </td>
                                  {sektorID != 2 && (
                                    <td>
                                      <span className='d-block fs-6 py-3'>
                                        {i18next.language === 'en'
                                          ? data.request_quantum?.toLocaleString('en', {
                                              maximumFractionDigits: 4,
                                            })
                                          : data.request_quantum?.toLocaleString('id', {
                                              maximumFractionDigits: 4,
                                            })}{' '}
                                        {data.sector_id === 3 ? ' MT' : ' Ton'}
                                      </span>
                                    </td>
                                  )}

                                  <td>
                                    <span className='d-block fs-6 py-3'>
                                      {i18next.language === 'en'
                                        ? data.fixed_quantum?.toLocaleString('en', {
                                            maximumFractionDigits: 4,
                                          })
                                        : data.fixed_quantum?.toLocaleString('id', {
                                            maximumFractionDigits: 4,
                                          })}{' '}
                                      {data.sector_id === 3 ? ' MT' : ' Ton'}
                                    </span>
                                  </td>

                                  {sektorID != 2 && (
                                    <>
                                      {data.is_formulated_price ? (
                                        <>
                                          <td>
                                            <span className='d-block fs-6 py-3'>
                                              {t('Formulated Price')}
                                            </span>
                                          </td>
                                        </>
                                      ) : (
                                        <>
                                          {sektorID == 1 ? (
                                            <>
                                              <td>
                                                <span className='d-block fs-6 py-3'>
                                                  {'Rp ' + (i18next.language === 'en'
                                                    ? data.request_price?.toLocaleString('en', {
                                                        maximumFractionDigits: 4,
                                                      })
                                                    : data.request_price?.toLocaleString('id', {
                                                        maximumFractionDigits: 4,
                                                      }))}
                                                  /{data.sector_id === 3 ? ' MT' : ' Ton'}
                                                </span>
                                              </td>
                                            </>
                                          ) : (
                                            <>
                                              <td>
                                                <span className='d-block fs-6 py-3'>
                                                  USD {PriceFormater(data.request_price)} /MT
                                                </span>
                                              </td>
                                            </>
                                          )}
                                        </>
                                      )}
                                    </>
                                  )}

                                  {sektorID != 3 ? (
                                    <td>
                                      <span className='d-block fs-6 py-3'>
                                        {'Rp' + (i18next.language === 'en'
                                          ? data.fixed_price?.toLocaleString('en', {
                                              maximumFractionDigits: 4,
                                            })
                                          : data.fixed_price?.toLocaleString('id', {
                                              maximumFractionDigits: 4,
                                            }))}
                                        /{data.sector_id === 3 ? ' MT' : ' Ton'}
                                      </span>
                                    </td>
                                  ) : (
                                    <td>
                                      <span className='d-block fs-6 py-3'>
                                        USD {PriceFormater(data.fixed_price)} /MT
                                      </span>
                                    </td>
                                  )}
                                  {data.sector_id == 1 && (
                                    <td>
                                      <span className='d-block fs-6 py-3'>
                                        {data.quantum_contract ? 'Include PPN' : 'Exclude PPN'}
                                      </span>
                                    </td>
                                  )}
                                  <td>
                                    <span className='d-block fs-6 py-3'>
                                      {i18next.language === 'en'
                                        ? parseInt(data.quantum_contract)?.toLocaleString('en', {
                                            maximumFractionDigits: 4,
                                          })
                                        : parseInt(data.quantum_contract)?.toLocaleString('id', {
                                            maximumFractionDigits: 4,
                                          })}{' '}
                                      {data.sector_id === 3 ? ' MT' : ' Ton'}
                                    </span>
                                  </td>
                                  <td>
                                    <span className='d-block fs-6 py-3'>
                                      {i18next.language === 'en'
                                        ? data.quantum_realisazied?.toLocaleString('en', {
                                            maximumFractionDigits: 4,
                                          })
                                        : data.quantum_realisazied?.toLocaleString('id', {
                                            maximumFractionDigits: 4,
                                          })}{' '}
                                      {data.sector_id === 3 ? ' MT' : ' Ton'}
                                    </span>
                                  </td>
                                  <td>
                                    <span className='d-block fs-6 py-3'>
                                      {i18next.language === 'en'
                                        ? data.quantum_do?.toLocaleString('en', {
                                            maximumFractionDigits: 4,
                                          })
                                        : data.quantum_do?.toLocaleString('id', {
                                            maximumFractionDigits: 4,
                                          })}{' '}
                                      {data.sector_id === 3 ? ' MT' : ' Ton'}
                                    </span>
                                  </td>
                                  <td>
                                    <span className='d-block fs-6 py-3'>
                                      {i18next.language === 'en'
                                        ? data.outstanding_quantum_so?.toLocaleString('en', {
                                            maximumFractionDigits: 4,
                                          })
                                        : data.outstanding_quantum_so?.toLocaleString('id', {
                                            maximumFractionDigits: 4,
                                          })}{' '}
                                      {data.sector_id === 3 ? ' MT' : ' Ton'}
                                    </span>
                                  </td>
                                  <td>
                                    <span className='d-block fs-6 py-3'>
                                      {i18next.language === 'en'
                                        ? data.left_over_quantum_no_st?.toLocaleString('en', {
                                            maximumFractionDigits: 4,
                                          })
                                        : data.left_over_quantum_no_st?.toLocaleString('id', {
                                            maximumFractionDigits: 4,
                                          })}{' '}
                                      {data.sector_id === 3 ? ' MT' : ' Ton'}
                                    </span>
                                  </td>
                                  {data.sector_id == 2 && (
                                    <td>
                                      <span className='d-block fs-6 py-3'>{data.plant_desc}</span>
                                    </td>
                                  )}
                                </tr>
                              )
                            })}
                            {/* End Table Head */}
                          </TableUI.TBody>
                        </TableUI.Table>
                      </TableUI.TableWrapper>
                    </TableUI.TableDetail>
                  </div>

                  <div className='w-50 mt-5'>
                    {/* {price != 0 ? (
                      <Row className='mb-4'>
                        <Col md={4}>
                          <p className='fs-4 me-2 mt-2'>Total {t('kontrak-harga')}</p>
                        </Col>
                        <Col md={8}>
                          <Form.Control
                            aria-label='Default select example'
                            size='sm'
                            value={
                              i18next.language === 'en'
                                ? price?.toLocaleString('en', { maximumFractionDigits: 4 })
                                : price?.toLocaleString('id', { maximumFractionDigits: 4 })
                            }
                            disabled
                          />
                        </Col>
                      </Row>
                    ) : (
                      ''
                    )} */}

                    {quantum != 0 ? (
                      <Row className='mb-4'>
                        <Col md={4}>
                          <p className='fs-4 me-2 mt-2'>Total {t('kontrak-kuantum')}</p>
                        </Col>
                        <Col md={8}>
                          <Form.Control
                            aria-label='Default select example'
                            size='sm'
                            value={
                              (i18next.language === 'en'
                                ? quantum?.toLocaleString('en', {maximumFractionDigits: 4})
                                : quantum?.toLocaleString('id', {maximumFractionDigits: 4})) +
                              ' ' +
                              'Ton'
                            }
                            disabled
                          />
                        </Col>
                      </Row>
                    ) : (
                      ''
                    )}

                    {quantum != 0 ? (
                      <Row className='mb-4'>
                        <Col md={4}>
                          <p className='fs-4 me-2 mt-2'>{t('Total Nilai')}</p>
                        </Col>
                        <Col md={8}>
                          {sektorID != 3 ? (
                            grandtotalUsd ? <Form.Control
                              aria-label='Default select example'
                              size='sm'
                              value={
                                'USD ' + (i18next.language === 'en'
                                  ? grandtotalUsd.toLocaleString('en', {maximumFractionDigits: 4})
                                  : grandtotalUsd.toLocaleString('id', {maximumFractionDigits: 4}))
                              }
                              disabled
                            /> : <Form.Control
                              aria-label='Default select example'
                              size='sm'
                              value={
                                'Rp ' + (i18next.language === 'en'
                                  ? grandtotal.toLocaleString('en', {maximumFractionDigits: 4})
                                  : grandtotal.toLocaleString('id', {maximumFractionDigits: 4}))
                              }
                              disabled
                            />
                          ) : (
                            <Form.Control
                              aria-label='Default select example'
                              size='sm'
                              value={'USD ' + PriceFormater(grandtotal)}
                              disabled
                            />
                          )}
                        </Col>
                      </Row>
                    ) : (
                      ''
                    )}
                  </div>

                  <div className='d-flex justify-content-end mt-5'>
                    <Button
                      variant='secondary'
                      className='me-2'
                      type='submit'
                      onClick={() => navigate('/management/si/all')}
                    >
                      <i className='fas fa-chevron-left'></i> {t('sip-batal')}
                    </Button>

                    {approveFlag ? (
                      <>
                        {/* <Button
                          variant='danger'
                          className='me-2'
                          id='btn-reject'
                          onClick={() => setShowReject(true)}
                        >
                          {t('order-tolak')}
                        </Button>

                        <Button
                          variant='warning'
                          className='me-2'
                          id='btn-revision'
                          onClick={() => setShowRevision(true)}
                        >
                          Revisi
                        </Button>

                        <Button
                          variant='success'
                          className='me-2'
                          id='btn-approve'
                          onClick={() => setShowApprove(true)}
                        >
                          Approve
                        </Button> */}
                      </>
                    ) : (
                      <></>
                    )}
                  </div>
                </>
              )}
              {(roleUser == 'salesAdmin' ||
                roleUser == 'salesAnper' ||
                roleUser == 'otorisator') && (
                <>
                  <Row>
                    <Col md={6}>
                      <Row className='mb-3'>
                        <Col md={4}>
                          <p className='fs-4 mt-2'>
                            {t('sip-pengajuan')} {t('Order')}{' '}
                          </p>
                        </Col>
                        <Col md={8}>
                          <Form.Control type='text' defaultValue={sipNumber} disabled size='sm' />
                        </Col>
                      </Row>
                      <Row className='mb-3'>
                        <Col md={4}>
                          <p className='fs-4 mt-2'>{t('Customer Name')}</p>
                        </Col>
                        <Col md={8}>
                          <Form.Control
                            type='text'
                            value={customerName}
                            placeholder={t('Customer Name')}
                            disabled
                            size='sm'
                          />
                        </Col>
                      </Row>

                      <Row className='mb-3'>
                        <Col md={4}>
                          <p className='fs-4 mt-2'>{t('Start-Date')}</p>
                        </Col>
                        <Col md={8}>
                          <Form.Control
                            type='text'
                            placeholder={t('Start-Date')}
                            defaultValue={dateformat(dateFrom)}
                            disabled
                            size='sm'
                          />
                        </Col>
                      </Row>

                      <Row className='mb-3'>
                        <Col md={4} className='d-flex align-items-center'>
                          <p className='fs-4'>{t('Tanggal Pengajuan SIP')}</p>
                        </Col>
                        <Col md={8}>
                          <Form.Control
                            type='text'
                            placeholder={t('Tanggal Pengajuan SIP')}
                            defaultValue={dateformat(perihalTanggal)}
                            disabled
                            size='sm'
                          />
                        </Col>
                      </Row>
                    </Col>
                    <Col md={6}>
                      <Row className='mb-3'>
                        <Col md={4}>
                          <p className='fs-4 mt-2'>{t('Customer Number')}</p>
                        </Col>
                        <Col md={8}>
                          <Form.Control
                            type='text'
                            value={customerCode}
                            placeholder={t('Customer Number')}
                            disabled
                            size='sm'
                          />
                        </Col>
                      </Row>
                      <Row className='mb-3'>
                        <Col md={4}>
                          <p className='fs-4 mt-2'>{t('Address')}</p>
                        </Col>
                        <Col md={8}>
                          <Form.Control
                            as='textarea'
                            value={customerAddress}
                            placeholder={t('Address')}
                            disabled
                            size='sm'
                          />
                        </Col>
                      </Row>
                      <Row className='mb-3'>
                        <Col md={4}>
                          <p className='fs-4 mt-2'>{t('End-Date')}</p>
                        </Col>
                        <Col md={8}>
                          <Form.Control
                            type='text'
                            placeholder={t('End-Date')}
                            defaultValue={dateformat(dateTo)}
                            disabled
                            size='sm'
                          />
                        </Col>
                      </Row>
                      <Row className='mb-3'>
                        <Col md={4} className='d-flex align-items-center'>
                          <p className='fs-4'>{t('Metode Pembayaran')}</p>
                        </Col>
                        <Col md={8}>
                          <Form.Control
                            style={{height: '40px'}}
                            value={paymentMethod}
                            placeholder={t('Metode Pembayaran')}
                            disabled
                            size='sm'
                          />
                        </Col>
                      </Row>

                      <Row className='mb-3'>
                        <Col md={4}>
                          <p className='fs-4 mt-2'>{t('order-perihal')}</p>
                        </Col>
                        <Col md={8}>
                          <Form.Control
                            placeholder={t('order-perihal')}
                            aria-label='Default select example'
                            size='sm'
                            value={regarding == 'PO001' ? t('penjualan') : t('Non-penjualan')}
                            disabled
                          />
                        </Col>
                      </Row>
                    </Col>
                  </Row>

                  <hr />

                  <div className='card-toolbar mt-10 d-flex justify-content-end mt-6 mb-2'>
                    <Button
                      onClick={() => {
                        setShowLetter(true)
                      }}
                      className='btn btn-primary me-2 fw-semibold d-flex align-items-center'
                      data-bs-toggle='tooltip'
                      data-bs-placement='top'
                      data-bs-trigger='hover'
                      title={t('preview')}
                    >
                      <i className='fa fa-eye'></i>
                      {t('preview')}
                    </Button>
                    {/* {sipStatus > 3 && sipStatus < 9 && (
                    )} */}
                    <Button
                          variant='primary'
                          onClick={() => {
                            setAttachmentType('sip')
                            setSubOrderID(SIPId || '')
                            ambilAttachment(SIPId, 'sip')
                          }}
                        >
                          <i className='fa fa-file'></i>
                          {t('order-lampiran')}
                    </Button>

                    <Button
                          disabled={loadingDownloadDraft}
                          variant='primary'
                          className='ms-2'
                          onClick={handleDownloadDraft}
                        >
                          {
                            loadingDownloadDraft ? <i className='fa fa-spin fa-spinner'></i> : <>
                              <i className='fa fa-download'></i>
                              {[4,5,6,7,8,9,11].includes(sipStatus) ? t('donwload-SIP') : t('download-sip')}
                            </>
                          }
                    </Button>

                    <Button
                      variant='primary'
                      className='ms-2'
                      title={t('history-sip-amendment')}
                      onClick={() => {
                        setShowModalHistory(true)
                      }}
                    >
                      <KTSVG
                        path='/media/icons/duotune/file-earmark-arrow-down-fill.svg'
                        className='svg-icon-3'
                      />
                      {t('history-sip-amendment')}
                    </Button>

                     <Button
                      variant='primary'
                      className='ms-2'
                      onClick={() => {
                        setShowApprovalHistory(true)
                      }}
                      data-bs-toggle='tooltip'
                      data-bs-placement='top'
                      data-bs-trigger='hover'
                      title={t('Approval')}
                    >
                      <i className='fas fa-check'></i> {t('Approval')}
                    </Button>
                  </div>

                  <div className='table-responsive mt-5 bdr'>
                    {/* Table Head */}
                    <TableUI.TableDetail colSpan={14}>
                      <TableUI.TableWrapper style={{marginBottom: 0}}>
                        <TableUI.Table>
                          <TableUI.THead>
                            <tr style={{backgroundColor: '#274070'}}>
                              <th>{t('kontrak-item')}</th>
                              <th>Status</th>
                              <th>{t('kontrak-aksi')}</th>
                              <th>Sales Org</th>
                              <th>{t('kontrak-incoterm')}</th>
                              <th>{t('kontrak-wilayah')}</th>
                              {sektorID == 1 && <th>{t('segment')}</th>}
                              <th>{t('sub-order-endUser')}</th>
                              {sektorID == 2 && <th>{t('Sektor')}</th>}
                              <th>{t('kontrak-jenis')}</th>
                              <th>{t('Product Code')}</th>
                              <th>{t('kontrak-nama')}</th>
                              <th>{t('kontrak-spek')}</th>
                              {retailFlag == 'AR03' ? (
                                <>
                                  <th>{t('Kuantum Pengajuan')}</th>
                                  <th>{t('Harga Pengajuan')}</th>
                                  <th>{t('Shipping Tolerance')}</th>
                                </>
                              ) : (
                                <>
                                  <th>{t('Kuantum Pengajuan')}</th>
                                  {sektorID != 2 && <th>{t('sub-order-kuantumD')}</th>}
                                  <th>{t('Shipping Tolerance')}</th>
                                  <th>{t('Harga Pengajuan')}</th>
                                  {sektorID != 2 && <th>{t('sub-order-hargaD')}</th>}
                                </>
                              )}
                              {sektorID == 1 && <th>Status {t('Price')}</th>}
                              <th>{t('Tonase Kontrak')}</th>
                              <th>{t('Tonase SO')}</th>
                              <th>{t('Tonase DO')}</th>
                              <th>Outstanding SO</th>
                              <th>Outstanding {t('Kontrak')}</th>
                              {sektorID == 2 && <th>{t('kontrak-gudang')}</th>}
                            </tr>
                          </TableUI.THead>
                          <TableUI.TBody>
                            {dataSIPDetail.map((data: any, _index: any) => (
                              <>
                                <tr key={data?.id ?? _index}>
                                  <td>
                                    <span className='d-block fs-6 py-3'>{_index + 1}</span>
                                  </td>
                                  <td>
                                    <BadgeColorSIP
                                      status={data?.status_sip}
                                      text={data?.status_text_sip}
                                      type='header'
                                    />
                                  </td>
                                  <td>
                                    <div
                                      className='d-flex justify-content-center align-items-center'
                                      style={{margin: '-1px 0 0 0'}}
                                    >
                                      <button
                                        className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                        data-bs-toggle='tooltip'
                                        data-bs-placement='top'
                                        data-bs-trigger='hover'
                                        title='Detail'
                                        onClick={() => handleShowOrderDetail(data)}
                                      >
                                        <KTSVG
                                          path='/media/icons/duotune/file-text-fill.svg'
                                          className='svg-icon-3'
                                        />
                                      </button>
                                      <button
                                        className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                        data-bs-toggle='tooltip'
                                        data-bs-placement='top'
                                        data-bs-trigger='hover'
                                        title={t('order-lampiran')}
                                        onClick={() => {
                                          setAttachmentType('order-item')
                                          setIsLoadingModal(false)
                                          setShowUpload(true)
                                          setFileBox(data)
                                          setSubOrderID(
                                            data.order_sub_item_id == null
                                              ? data?.id
                                              : data?.order_sub_item_id
                                          )
                                          setSIPNumberAttactment(data.SIP_number)
                                          ambilAttachment(
                                            data.order_sub_item_id == null
                                              ? data?.id
                                              : data?.order_sub_item_id
                                          ,'order-item')
                                        }}
                                      >
                                        <KTSVG
                                          path='/media/icons/duotune/archive-fill.svg'
                                          className='svg-icon-3'
                                        />
                                      </button>
                                      <button
                                        className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                        data-bs-toggle='tooltip'
                                        data-bs-placement='top'
                                        data-bs-trigger='hover'
                                        title={t('Jadwal')}
                                        onClick={() => {
                                          setIDSector(data.sector_id)
                                          setProvinceName(data.province?.region_name)
                                          setCityName(data.city?.city_name)
                                          setProductName(data.product_name)
                                          formattingTon(data.fixed_quantum)
                                          setSubOrderID(
                                            data.order_sub_item_id == null
                                              ? data?.id
                                              : data?.order_sub_item_id
                                          )
                                          handleshowjadwal()
                                        }}
                                      >
                                        <KTSVG
                                          path='/media/icons/duotune/calendar-check-fill.svg'
                                          className='svg-icon-3'
                                        />
                                      </button>
                                    </div>
                                  </td>
                                  <td>
                                    <span className='d-block fs-6 py-3'>{data.produsen?.name}</span>
                                  </td>
                                  {data.sector?.id == 2 ? (
                                    <>
                                      {data.incoterm2 == null ? (
                                        <td>
                                          <span className='d-block fs-6 py-3'>
                                            {data.incoterm1?.code}-{data.incoterm2_id}
                                          </span>
                                        </td>
                                      ) : (
                                        <td>
                                          <span className='d-block fs-6 py-3'>
                                            {data.incoterm1?.code}-{data.incoterm2?.code}
                                          </span>
                                        </td>
                                      )}
                                    </>
                                  ) : (
                                    <>
                                      {data.incoterm2 == null ? (
                                        <td>
                                          <span className='d-block fs-6 py-3'>
                                            {data.incoterm1?.code}
                                            {data.incoterm2_id == null || data.incoterm2_id == '0'
                                              ? ''
                                              : '-' + data.incoterm2_id}
                                          </span>
                                        </td>
                                      ) : (
                                        <td>
                                          <span className='d-block fs-6 py-3'>
                                            {data.incoterm1?.code}-{data.incoterm2?.code}
                                          </span>
                                        </td>
                                      )}
                                    </>
                                  )}
                                  <td>
                                    <span className='d-block fs-6 py-3'>
                                      <PopoverText
                                        content={
                                          data.province?.region_name ||
                                          '' +
                                            (data.city?.city_name
                                              ? ', ' + data.city?.city_name
                                              : '')
                                        }
                                        index={_index}
                                        className='spec-sliceee'
                                      />
                                    </span>
                                  </td>
                                  {sektorID == 2 && (
                                    <td>
                                      <span className='d-block fs-6 py-3'>
                                        {t(data.sector?.name)}
                                      </span>
                                    </td>
                                  )}
                                  {sektorID == 1 && (
                                    <td>
                                      <span className='d-block fs-6 py-3'>
                                        {t(data.segment_name)}
                                      </span>
                                    </td>
                                  )}
                                  <td>
                                    <span className='d-block fs-6 py-3'>
                                      <PopoverText
                                        content={getEndUser(data)}
                                        index={_index}
                                        className='desc-slicee'
                                      />
                                    </span>
                                  </td>
                                  <td>
                                    <span className='d-block fs-6 py-3'>
                                      {data.product_type_desc}
                                    </span>
                                  </td>
                                  <td>
                                    <span className='d-block fs-6 py-3'>
                                      {parseInt(data.material_number) == 0
                                        ? ''
                                        : data.material_number?.slice(-7)}
                                    </span>
                                  </td>
                                  <td>
                                    <span className='d-block fs-6 py-3'>{data.product_name}</span>
                                  </td>
                                  <td>
                                    <span className='d-block fs-6 py-3'>
                                      <PopoverText
                                        content={data.product_spec || '-'}
                                        index={_index}
                                        className='spec-sliceee'
                                      />
                                    </span>
                                  </td>
                                  {retailFlag == 'AR03' ? (
                                    <>
                                      {sektorID != 2 && (
                                        <td>
                                          <span className='d-block fs-6 py-3'>
                                            {i18next.language === 'en'
                                              ? data.request_quantum?.toLocaleString('en', {
                                                  maximumFractionDigits: 4,
                                                })
                                              : data.request_quantum?.toLocaleString('id', {
                                                  maximumFractionDigits: 4,
                                                })}{' '}
                                            {data.sector_id === 3 ? ' MT' : ' Ton'}
                                          </span>
                                        </td>
                                      )}

                                      <td>
                                        <span className='d-block fs-6 py-3'>
                                          {i18next.language === 'en'
                                            ? data.fixed_quantum?.toLocaleString('en', {
                                                maximumFractionDigits: 4,
                                              })
                                            : data.fixed_quantum?.toLocaleString('id', {
                                                maximumFractionDigits: 4,
                                              })}{' '}
                                          {data.sector_id === 3 ? ' MT' : ' Ton'}
                                        </span>
                                      </td>
                                      <td>
                                        <span className='d-block fs-6 py-3'>
                                          {data?.shipping_tolerance}%
                                        </span>
                                      </td>

                                      {sektorID != 2 && (
                                        <>
                                          {data.is_formulated_price ? (
                                            <>
                                              <td>
                                                <span className='d-block fs-6 py-3'>
                                                  {t('Formulated Price')}
                                                </span>
                                              </td>
                                            </>
                                          ) : (
                                            <>
                                              {sektorID == 1 ? (
                                                <>
                                                  <td>
                                                    <span className='d-block fs-6 py-3'>
                                                      {'Rp ' + (i18next.language === 'en'
                                                        ? data.request_price?.toLocaleString('en', {
                                                            maximumFractionDigits: 4,
                                                          })
                                                        : data.request_price?.toLocaleString('id', {
                                                            maximumFractionDigits: 4,
                                                          }))}
                                                      /Ton
                                                    </span>
                                                  </td>
                                                </>
                                              ) : (
                                                <>
                                                  <td>
                                                    <span className='d-block fs-6 py-3'>
                                                      USD {PriceFormater(data.request_price)} /MT
                                                    </span>
                                                  </td>
                                                </>
                                              )}
                                            </>
                                          )}
                                        </>
                                      )}

                                      {sektorID != 3 ? (
                                        <td>
                                          <span className='d-block fs-6 py-3'>
                                            {'Rp ' + (i18next.language === 'en'
                                              ? data.fixed_price?.toLocaleString('en', {
                                                  maximumFractionDigits: 4,
                                                })
                                              : data.fixed_price?.toLocaleString('id', {
                                                  maximumFractionDigits: 4,
                                                }))}
                                            /Ton
                                          </span>
                                        </td>
                                      ) : (
                                        <td>
                                          <span className='d-block fs-6 py-3'>
                                            USD {PriceFormater(data.fixed_price)} /MT
                                          </span>
                                        </td>
                                      )}
                                    </>
                                  ) : (
                                    <>
                                      {sektorID != 2 && (
                                        <td>
                                          <span className='d-block fs-6 py-3'>
                                            {i18next.language === 'en'
                                              ? data.request_quantum?.toLocaleString('en', {
                                                  maximumFractionDigits: 4,
                                                })
                                              : data.request_quantum?.toLocaleString('id', {
                                                  maximumFractionDigits: 4,
                                                })}{' '}
                                            {data.sector_id === 3 ? ' MT' : ' Ton'}
                                          </span>
                                        </td>
                                      )}

                                      <td>
                                        <span className='d-block fs-6 py-3'>
                                          {i18next.language === 'en'
                                            ? data.fixed_quantum?.toLocaleString('en', {
                                                maximumFractionDigits: 4,
                                              })
                                            : data.fixed_quantum?.toLocaleString('id', {
                                                maximumFractionDigits: 4,
                                              })}{' '}
                                          {data.sector_id === 3 ? ' MT' : ' Ton'}
                                        </span>
                                      </td>

                                      <td>
                                        <span className='d-block fs-6 py-3'>
                                          {data?.shipping_tolerance}%
                                        </span>
                                      </td>

                                      {sektorID != 2 && (
                                        <>
                                          {data.is_formulated_price ? (
                                            <>
                                              <td>
                                                <span className='d-block fs-6 py-3'>
                                                  {t('Formulated Price')}
                                                </span>
                                              </td>
                                            </>
                                          ) : (
                                            <>
                                              {sektorID == 1 ? (
                                                <>
                                                  <td>
                                                    <span className='d-block fs-6 py-3'>
                                                      {'Rp ' + (i18next.language === 'en'
                                                        ? data.request_price?.toLocaleString('en', {
                                                            maximumFractionDigits: 4,
                                                          })
                                                        : data.request_price?.toLocaleString('id', {
                                                            maximumFractionDigits: 4,
                                                          }))}
                                                      /Ton
                                                    </span>
                                                  </td>
                                                </>
                                              ) : (
                                                <>
                                                  <td>
                                                    <span className='d-block fs-6 py-3'>
                                                      USD {PriceFormater(data.request_price)} /MT
                                                    </span>
                                                  </td>
                                                </>
                                              )}
                                            </>
                                          )}
                                        </>
                                      )}

                                      {sektorID != 3 ? (
                                        <td>
                                          <span className='d-block fs-6 py-3'>
                                            {'Rp ' + (i18next.language === 'en'
                                              ? data.fixed_price?.toLocaleString('en', {
                                                  maximumFractionDigits: 4,
                                                })
                                              : data.fixed_price?.toLocaleString('id', {
                                                  maximumFractionDigits: 4,
                                                }))}
                                            /Ton
                                          </span>
                                        </td>
                                      ) : (
                                        <td>
                                          <span className='d-block fs-6 py-3'>
                                            USD {PriceFormater(data.fixed_price)} /MT
                                          </span>
                                        </td>
                                      )}
                                    </>
                                  )}
                                  {data.sector_id == 1 && (
                                    <td>
                                      <span className='d-block fs-6 py-3'>
                                        {data.include_ppn ? 'Include PPN' : 'Exclude PPN'}
                                      </span>
                                    </td>
                                  )}
                                  <td>
                                    <span className='d-block fs-6 py-3'>
                                      {i18next.language === 'en'
                                        ? parseInt(data.quantum_contract)?.toLocaleString('en', {
                                            maximumFractionDigits: 4,
                                          })
                                        : parseInt(data.quantum_contract)?.toLocaleString('id', {
                                            maximumFractionDigits: 4,
                                          })}{' '}
                                      {data.sector_id === 3 ? ' MT' : ' Ton'}
                                    </span>
                                  </td>
                                  <td>
                                    <span className='d-block fs-6 py-3'>
                                      {i18next.language === 'en'
                                        ? data.quantum_realisazied?.toLocaleString('en', {
                                            maximumFractionDigits: 4,
                                          })
                                        : data.quantum_realisazied?.toLocaleString('id', {
                                            maximumFractionDigits: 4,
                                          })}{' '}
                                      {data.sector_id === 3 ? ' MT' : ' Ton'}
                                    </span>
                                  </td>
                                  <td>
                                    <span className='d-block fs-6 py-3'>
                                      {i18next.language === 'en'
                                        ? data.quantum_do?.toLocaleString('en', {
                                            maximumFractionDigits: 4,
                                          })
                                        : data.quantum_do?.toLocaleString('id', {
                                            maximumFractionDigits: 4,
                                          })}{' '}
                                      {data.sector_id === 3 ? ' MT' : ' Ton'}
                                    </span>
                                  </td>
                                  <td>
                                    <span className='d-block fs-6 py-3'>
                                      {i18next.language === 'en'
                                        ? data.outstanding_quantum_so?.toLocaleString('en', {
                                            maximumFractionDigits: 4,
                                          })
                                        : data.outstanding_quantum_so?.toLocaleString('id', {
                                            maximumFractionDigits: 4,
                                          })}{' '}
                                      {data.sector_id === 3 ? ' MT' : ' Ton'}
                                    </span>
                                  </td>
                                  <td>
                                    <span className='d-block fs-6 py-3'>
                                      {i18next.language === 'en'
                                        ? data.left_over_quantum_no_st?.toLocaleString('en', {
                                            maximumFractionDigits: 4,
                                          })
                                        : data.left_over_quantum_no_st?.toLocaleString('id', {
                                            maximumFractionDigits: 4,
                                          })}{' '}
                                      {data.sector_id === 3 ? ' MT' : ' Ton'}
                                    </span>
                                  </td>
                                  {data.sector_id == 2 ? (
                                    <td>
                                      <span className='d-block fs-6 py-3'>
                                        <PopoverText
                                          content={data.plant_desc || '-'}
                                          index={_index}
                                          placement='bottom'
                                          className='spec-sliceee'
                                        />
                                      </span>
                                    </td>
                                  ) : (
                                    ''
                                  )}
                                </tr>
                              </>
                            ))}
                          </TableUI.TBody>
                        </TableUI.Table>
                      </TableUI.TableWrapper>
                    </TableUI.TableDetail>
                    {/* End Table Head */}
                  </div>

                  <table className='mt-4'>
                    <tr>
                      <td className='td-250'>
                        <p className='fs-4 me-2'>Total {t('kontrak-kuantum')}</p>
                      </td>
                      <td>
                        <Form.Control
                          aria-label='Default select example'
                          size='sm'
                          value={
                            (i18next.language === 'en'
                              ? quantum?.toLocaleString('en', {maximumFractionDigits: 4})
                              : quantum?.toLocaleString('id', {maximumFractionDigits: 4})) +
                            ' ' +
                            'Ton'
                          }
                          disabled
                        />
                      </td>
                    </tr>
                  </table>

                  <table className='mt-4'>
                    <tr>
                      <td className='td-250'>
                        <p className='fs-4 me-2'>{t('Grand Total')}</p>
                      </td>
                      <td>
                        {sektorID != 3 ? (
                          grandtotalUsd ? <Form.Control
                              aria-label='Default select example'
                              size='sm'
                              value={
                                'USD ' + (i18next.language === 'en'
                                  ? grandtotalUsd.toLocaleString('en', {maximumFractionDigits: 4})
                                  : grandtotalUsd.toLocaleString('id', {maximumFractionDigits: 4}))
                              }
                              disabled
                            /> : <Form.Control
                              aria-label='Default select example'
                              size='sm'
                              value={
                                'Rp ' + (i18next.language === 'en'
                                  ? grandtotal.toLocaleString('en', {maximumFractionDigits: 4})
                                  : grandtotal.toLocaleString('id', {maximumFractionDigits: 4}))
                              }
                              disabled
                            />
                        ) : (
                          <Form.Control
                            aria-label='Default select example'
                            size='sm'
                            value={'USD' + PriceFormater(grandtotal)}
                            disabled
                          />
                        )}
                      </td>
                    </tr>
                  </table>

                  <div className='d-flex justify-content-end mt-5'>
                    <Button
                      variant='secondary'
                      className='me-2'
                      onClick={() => navigate('/management/si/all')}
                    >
                      {t('Back')}
                    </Button>
                    {/* <Button
                      hidden={roleUser == 'salesAdmin' && rollbackFlag ? false : true}
                      variant='primary'
                      className='me-2'
                      onClick={() => rollback()}
                    >
                      {btnLoading ? (
                        <Spinner animation='border' variant='light' size='sm' />
                      ) : (
                        <>{t('Rollback Ke') + ' ' + t('Create SIP')}</>
                      )}
                    </Button> */}
                  </div>
                </>
              )}
            </>
          ) : (
            <SkeletonPageDetail />
          )}
        </div>

        <Modal
          show={showApprovalHistory}
          onHide={() => setShowApprovalHistory(false)}
          backdrop='static'
          keyboard={false}
          scrollable
        >
          <Modal.Header closeButton>
            <Modal.Title>{t('Approval')}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <ApprovalHistory reviewers={reviewers} approvers={approvers}/>
          </Modal.Body>
        </Modal>

        <Modal
          show={showLetter}
          onHide={() => setShowLetter(false)}
          size='xl'
          backdrop='static'
          keyboard={false}
          scrollable
        >
          <Modal.Header closeButton>
            <Modal.Title>{t('preview')}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <ViewLetter data={LetterData} type='sip' />
          </Modal.Body>
        </Modal>

        <Modal
          size='lg'
          show={showUpload}
          onHide={() => {
            setShowUpload(false)
            setSIPNumberAttactment(null)
            setIsPrivate(false)
            setTempRole([])
            setFileBox({})
          }}
          backdrop='static'
          keyboard={false}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>
            {
              attachmentType == 'order-item' ? (fileBox?.product_name
                ? (fileBox.province ? fileBox.province?.region_name : '') +
                  (fileBox.city ? ', ' + fileBox.city?.city_name : '') +
                  (fileBox.province ? ' | ' : '') +
                  fileBox.product_name +
                  (fileBox.request_quantum ? ' | ' + fileBox.request_quantum + ' Ton' : '')
                : t('File Box'))
              : <span>{t('File Box')}</span>
            }
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {isLoadingModal ? (
              <Skeleton width={100} height={30} />
            ) : (
              <>
                <Row>
                  <Col sm={6}>
                    <table className='mb-3'>
                      <tr>
                        <td style={{width: '120px'}}>
                          <h6>{t('order-fileUnggah')}</h6>
                        </td>
                        <td className='w-75'>
                          <InputFile
                              setFileName={setNamaFile}
                              setFiles={setFiles}
                              isBase64={false}
                          />
                        </td>
                      </tr>
                    </table>
                    <table className='mb-3'>
                      <tr>
                        <td style={{width: '120px'}}>
                          <h6>{t('order-keterangan')}</h6>
                        </td>
                        <td className='w-75'>
                          <Form.Control
                            type='text'
                            placeholder={t('order-keterangan')}
                            onChange={(e: any) => setDescription(e.target.value)}
                            value={description}
                          />
                        </td>
                      </tr>
                    </table>
                    <table
                      className='mb-3'
                      hidden={roleUser == 'null' || roleUser == null ? true : false}
                    >
                      <tr>
                        <td>
                          <h6 className='me-11'>{t('Private')}</h6>
                        </td>
                        <td className='w-75 d-flex justify-content-start'>
                          <Form.Check
                            reverse
                            name='isPrivate'
                            type='checkbox'
                            className='mt-5 mb-2'
                            onClick={() => {
                              setIsPrivate(!isPrivate)
                              setTempRole([])
                            }}
                            id='isPrivate'
                          />
                        </td>
                      </tr>
                    </table>
                    <table className='mb-3' hidden={isPrivate ? false : true}>
                      <tr>
                        <td style={{width: '120px'}}>
                          <h6>{t('Akses Role')}</h6>
                        </td>
                        <td className='w-75' style={{maxWidth: '274px'}}>
                          <MultiSelect
                            key={isPrivate.toString()}
                            options={fullRole?.map((item: any) => {
                              return {label: item.label, value: item.value}
                            })}
                            value={tempRole}
                            onChange={(e: any) => setTempRole(e)}
                            labelledBy='Select'
                          />
                        </td>
                      </tr>
                    </table>
                    <div className='d-flex justify-content-end'>
                      <Button
                        variant='primary'
                        className='w-100'
                        onClick={() => handleUpload()}
                        disabled={btnLoading}
                      >
                        {btnLoading ? <Spinner animation='border' size='sm' /> : t('order-kirim')}
                      </Button>
                    </div>
                  </Col>
                </Row>
                <div className='table-responsive mt-4 bdr'>
                  <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                    <thead className='fw-bold border-bottom'>
                      <tr className=''>
                        <th className='text-center'>{t('order-noo')}</th>
                        <th className='text-center'>{t('order-keterangan')}</th>
                        <th className='text-center'>{t('order-tglUpload')}</th>
                        {/* <th className='text-center'>{t('User Code')}</th> */}
                        <th className='text-center'>{t('order-user')}</th>
                        <th className='text-center'>{t('Akses Role')}</th>
                        <th className='text-center'>{t('order-aksi')}</th>
                      </tr>
                    </thead>
                    {allFiles.map((data: any, _index: any) => (
                      <tbody key={data?.id ?? _index}>
                        <tr className=''>
                          <td className='text-center'>
                            <label>{_index + 1}</label>
                          </td>
                          <td className='text-center'>
                            <label>{data.description}</label>
                          </td>
                          <td className='text-center'>
                            <label>{dateformat(data.updated_at)}</label>
                          </td>
                          {/* <td className='text-center'>
                            <label>{data.user?.customer_code || data.user?.nama_pengguna}</label>
                          </td> */}
                          <td className='text-center'>
                            {data.user?.customer_code == null ? (
                              <label>{data.user?.name}</label>
                            ) : (
                              <label>{data.user?.customer?.name}</label>
                            )}
                          </td>
                          <td className='text-center'>
                            {data.private ? (
                              data.roles.length > 0 ? (
                                <PopoverText
                                  content={handleShowRoleName(data.roles)}
                                  index={_index}
                                  className='desc-slice'
                                />
                              ) : (
                                'Private'
                              )
                            ) : (
                              'Public'
                            )}
                          </td>
                          <td className='text-center'>
                            <button
                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                              data-bs-toggle='tooltip'
                              data-bs-placement='top'
                              data-bs-trigger='hover'
                              title={t('unduh')}
                              onClick={() =>
                                handleDownloadAttachment(data.file_path)
                              }
                            >
                              <KTSVG
                                path='/media/icons/duotune/arrow-down-square-fill.svg'
                                className='svg-icon-3'
                              />
                            </button>
                            {(hasDeleteAttachment ||
                              CheckSameIDAttachment(data.user_role_flag)) && (
                              <button
                                onClick={() => deleteAttachment(data.id)}
                                className={`btn btn-icon btn-bg-light btn-active-color-primary btn-sm`}
                                data-bs-toggle='tooltip'
                                data-bs-placement='top'
                                data-bs-trigger='hover'
                                title={t('Hapus')}
                              >
                                <KTSVG
                                  path='/media/icons/duotune/trash-fill.svg'
                                  className='svg-icon-3'
                                />
                              </button>
                            )}
                          </td>
                        </tr>
                      </tbody>
                    ))}
                  </table>
                </div>
              </>
            )}
          </Modal.Body>
        </Modal>

        <Modal show={showRevision} onHide={() => setShowRevision(false)} centered backdrop='static'>
          <Modal.Header closeButton>
            <Modal.Title>{t('Revision Reason')}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <FloatingLabel controlId='floatingTextarea2' label={t('order-alasan')}>
              <Form.Control
                as='textarea'
                placeholder={t('Tinggal-pesan')}
                style={{height: '100px'}}
                onChange={(e: any) => {
                  setRevisionNote(e.target.value)
                }}
              />
            </FloatingLabel>
          </Modal.Body>
          <Modal.Footer>
            <Button variant='secondary' onClick={() => setShowRevision(false)}>
              {t('order-tutup')}
            </Button>
            <Button variant='warning' onClick={Revision} disabled={btnLoading}>
              {btnLoading ? <Spinner animation='border' variant='light' size='sm' /> : 'Ok'}
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal show={showReject} onHide={() => setShowReject(false)} centered backdrop='static'>
          <Modal.Header closeButton>
            <Modal.Title>{t('Reject Reason')}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <FloatingLabel controlId='floatingTextarea2' label={t('order-alasan')}>
              <Form.Control
                as='textarea'
                placeholder={t('Tinggal-pesan')}
                style={{height: '100px'}}
                onChange={(e: any) => setRejectNote(e.target.value)}
              />
            </FloatingLabel>
          </Modal.Body>
          <Modal.Footer>
            <Button variant='secondary' onClick={() => setShowReject(false)}>
              {t('order-tutup')}
            </Button>
            <Button variant='danger' onClick={Reject} disabled={btnLoading}>
              {btnLoading ? <Spinner animation='border' variant='light' size='sm' /> : 'Ok'}
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal show={showApprove} onHide={() => setShowApprove(false)} centered backdrop='static'>
          <Modal.Header closeButton></Modal.Header>
          <Modal.Body>
            <h3 className='text-center mb-5'>{t('Approve')}?</h3>
            <div className='d-flex justify-content-center'>
              <Button variant='secondary me-2' onClick={() => setShowApprove(false)}>
                {t('sip-batal')}
              </Button>
              <Button variant='success' onClick={Approve} disabled={btnLoading}>
                {btnLoading ? <Spinner animation='border' variant='light' size='sm' /> : t('Ya')}
              </Button>
            </div>
          </Modal.Body>
        </Modal>

        <CustomModal
          title='Detail SIP'
          size='xl'
          show={showDetail}
          onHide={() => setShowDetail(false)}
        >
          <FormDetailSIP />
        </CustomModal>

        <Modal
          show={showJadwal}
          onHide={() => setShowJadwal(false)}
          centered
          size='xl'
          backdrop='static'
          keyboard={false}
          scrollable
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {idSektor != 3 ? provinceName + ', ' + cityName + ' | ' : ''}
              {productName} | {fixedQuantum} Ton
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <span style={{fontSize: '15px'}} className='fw-bold d-block'>
              {t('Jadwal')}
            </span>
            <AddRemoveJadwal id={subOrderID} is_amendment={'false'} />
          </Modal.Body>
        </Modal>

        <SIPHistories
          show={showModalHistory}
          id={SIPId}
          onCloseModal={() => setShowModalHistory(false)}
        />
      </div>
    </>
  )
}

export {SIPDetail}
